import React from 'react';
import './FooterComponent.css';

function FooterComponent() {
  return (
    <footer className="container-fluid">
    
    {/*<div className="container">
        <div className="row pt-5 pb-4 align-items-center text-md-start text-center">
            <div className="col-md-6 col-12 mb-md-0 mb-4">
                <div className="col-md-10 col-12">
                    <h2 className="fw-bold mb-4"></h2>
                    <p className="pb-sm-0 pb-4"></p>
                </div>
            </div>
            <div className="col-md-6 col-12">
                <div className="d-flex justify-content-md-end justify-content-center" id="inscription_newsletter">
                    <div className="d-flex px-3 py-2 align-items-center">
                        <i className="fas fa-envelope me-sm-3 me-0"></i>
                        <input className="py-3 px-4 me-3" type="text" name="newsletter" placeholder="" />
                        <button className="button px-md-4 px-3 py-3" onclick="addNewsletter();">
                            <span className="d-sm-inline-block d-none"></span>
                            <i className="d-sm-none d-inline-block far fa-paper-plane"></i>
                        </button>
                    </div>
                </div>
                <div className="d-block text-md-end text-center pt-2" id="response_newsletter"></div>
            </div>
        </div>
        <hr />
        <div className="row py-4">
            <div className="d-lg-block col-sm text-md-start text-center mb-sm-0 mb-5">
                <img className="col-sm-10 col-8" src="global/img/logo_themoneytizer_footer.png" alt=""/>
                <img className="col-sm-10 col-8 mt-5" src="global/img/iab_tcf_vendor.png" alt=""/>
            </div>
            <ul className="col-sm text-md-start text-center mb-sm-0 mb-4">
                <li><h4 className="fw-bold mb-md-4 mb-2"></h4></li>
                <li className="py-1"><a href="#format_classique"></a></li>
                <li className="py-1"><a href="#format_impactant"></a></li>
                <li className="py-1"><a href="#format_video"></a></li>
            </ul>
            <ul className="col-sm text-md-start text-center mb-sm-0 mb-4">
                <li><h4 className="fw-bold mb-md-4 mb-2"></h4></li>
            </ul>
            <ul className="col-sm text-md-start text-center mb-sm-0 mb-4">
                <li><h4 className="fw-bold mb-md-4 mb-2"></h4></li>
            </ul>
            <ul className="col-sm text-md-start text-center mb-sm-0 mb-4">
                <li><h4 className="fw-bold mb-md-4 mb-2"></h4></li>
                <li className="py-1"><a target="_blank" href=""></a></li>
                <li className="py-1"><a href=""></a></li>
                <li className="py-1"><a target="_blank" href=""></a></li>
                <li className="py-1"><a href=""></a></li>
                <li className="py-1"><a href=""></a></li>
                <li className="py-1"><a href=""></a></li>
                <li className="py-1"><a href=""></a></li>
            </ul>
            <ul className="col-sm text-md-start text-center mb-sm-0 mb-4">
                <li><h4 className="fw-bold mb-md-4 mb-2"></h4></li>
                <li className="py-1"><a href=""></a></li>
                <li className="py-1"><a href=""></a></li>
                <li className="py-1"><a href=""></a></li>
            </ul>
        </div>
        <hr />
        <div className="row py-4 text-center">
            <p className="col-md-4 col-12 mb-sm-0 mb-4">©Copyright The Moneytizer - </p>

            <ul className="col-md-4 col-12">
                <li></li>
                <li className="py-1 d-inline-block me-4"><a href=""></a></li>
                <li className="py-1 d-inline-block me-4"><a href=""></a></li>
                <li className="py-1 d-inline-block"><a target="_blank" href="https://cdn.themoneytizer.fr/media/accord_de_traitement_des_donnees_personnelles.pdf"></a></li>
            </ul>

            <div className="col-md-4 col-12">

            </div>
        </div>
    </div>*/}
</footer>
  );
}

export default FooterComponent;